export const Messages = {
    REGISTERING_USER: "Registering user to entity...",
    USER_ADDED_SUCCESS: "User was added to this entity successfully",
    USER_ALREADY_REGISTERED: "User is already registered to this entity",
    UNREGISTERING_USER: "Unregistering user to entity...",
    USER_REMOVED_SUCCESS: "User was removed successfully",
    ERROR_ADDING_USER: "Error adding user to entity",
    ERROR_REMOVING_USER: "Error removing user from entity",
};